const cache = new Map()
const DEFAULT_TTL_MS = 30_000

/**
 * In-process SSR cache for shared Contentful reads (dedupes _app + page GSSP).
 * @param {string} key
 * @param {() => Promise<*>} fetcher
 * @param {{ preview?: boolean, ttlMs?: number }} [options]
 */
export async function cachedSsrFetch(key, fetcher, options = {}) {
  const { preview = false, ttlMs = DEFAULT_TTL_MS } = options

  if (preview) {
    return fetcher()
  }

  const cacheKey = `${key}:published`
  const entry = cache.get(cacheKey)
  const now = Date.now()

  if (entry && now - entry.at < ttlMs) {
    return entry.value
  }

  const value = await fetcher()
  cache.set(cacheKey, { value, at: now })

  return value
}

export function clearSsrContentfulCache() {
  cache.clear()
}
